module.exports = __webpack_public_path__ + "static/media/205_SHOT_119_118.4aa8052a.webp";